(function() {
  var launcherSelector = '[data-bly-chat-launcher]';
  var widgetSelector = '#kustomer-ui-sdk-iframe';
  var hasStartedKustomer = false;
  var isLoadingKustomer = false;
  var hasBoundKustomerListeners = false;
  var widgetWatchInterval = null;
  var openFallbackTimer = null;

  function getLauncher() {
    return document.querySelector(launcherSelector);
  }

  function setLauncherLoading(isLoading) {
    var launcher = getLauncher();

    if (!launcher) {
      return;
    }

    launcher.classList.toggle('is-loading', isLoading);
    launcher.setAttribute('aria-busy', isLoading ? 'true' : 'false');
  }

  function revealLauncher() {
    var launcher = getLauncher();

    if (launcher) {
      launcher.hidden = false;
    }
  }

  function hideLauncher() {
    var launcher = getLauncher();

    if (launcher) {
      launcher.hidden = true;
    }
  }

  function getWidgetFrame() {
    return document.querySelector(widgetSelector);
  }

  function isWidgetVisible() {
    var frame = getWidgetFrame();
    var frameStyles;
    var frameRect;

    if (!frame) {
      return false;
    }

    frameStyles = window.getComputedStyle(frame);
    frameRect = frame.getBoundingClientRect();

    return (
      frameStyles.display !== 'none' &&
      frameStyles.visibility !== 'hidden' &&
      frameStyles.opacity !== '0' &&
      frameRect.width > 0 &&
      frameRect.height > 0
    );
  }

  function clearOpenFallback() {
    if (openFallbackTimer) {
      window.clearTimeout(openFallbackTimer);
      openFallbackTimer = null;
    }
  }

  function syncLauncherWithWidget() {
    if (isWidgetVisible()) {
      hideLauncher();
      setLauncherLoading(false);
      clearOpenFallback();
      return;
    }

    if (!isLoadingKustomer) {
      revealLauncher();
      setLauncherLoading(false);
    }
  }

  function startWidgetWatcher() {
    if (widgetWatchInterval) {
      return;
    }

    widgetWatchInterval = window.setInterval(syncLauncherWithWidget, 500);
  }

  function openStartedKustomer() {
    if (!window.Kustomer || typeof window.Kustomer.open !== 'function') {
      setLauncherLoading(false);
      revealLauncher();
      return;
    }

    window.Kustomer.open();
    startWidgetWatcher();
    clearOpenFallback();
    openFallbackTimer = window.setTimeout(function() {
      syncLauncherWithWidget();
    }, 5000);
  }

  function bindKustomerListeners() {
    if (
      hasBoundKustomerListeners ||
      !window.Kustomer ||
      typeof window.Kustomer.addListener !== 'function'
    ) {
      return;
    }

    hasBoundKustomerListeners = true;

    window.Kustomer.addListener('onOpen', function() {
      startWidgetWatcher();
      hideLauncher();
      setLauncherLoading(false);
      clearOpenFallback();
    });

    window.Kustomer.addListener('onClose', function() {
      revealLauncher();
      setLauncherLoading(false);
      clearOpenFallback();
    });
  }

  function startKustomer() {
    var launcher = getLauncher();

    if (!launcher || !window.Kustomer || typeof window.Kustomer.start !== 'function') {
      setLauncherLoading(false);
      revealLauncher();
      return;
    }

    if (hasStartedKustomer) {
      openStartedKustomer();
      return;
    }

    hasStartedKustomer = true;
    bindKustomerListeners();
    window.Kustomer.start(
      {
        brandId: launcher.dataset.kustomerBrandId,
        hideChatIcon: true
      },
      function() {
        openStartedKustomer();
      }
    );
  }

  function loadKustomer() {
    var launcher = getLauncher();
    var script;

    if (!launcher || isLoadingKustomer) {
      return;
    }

    if (window.Kustomer && typeof window.Kustomer.start === 'function') {
      startKustomer();
      return;
    }

    isLoadingKustomer = true;
    window.addEventListener(
      'kustomerLoaded',
      function() {
        isLoadingKustomer = false;
        startKustomer();
      },
      { once: true }
    );

    script = document.createElement('script');
    script.src = launcher.dataset.kustomerScriptUrl;
    script.async = true;
    script.dataset.kustomerApiKey = launcher.dataset.kustomerApiKey;
    script.onerror = function() {
      isLoadingKustomer = false;
      setLauncherLoading(false);
      revealLauncher();
    };

    document.body.appendChild(script);
  }

  function openKustomer() {
    setLauncherLoading(true);
    clearOpenFallback();
    loadKustomer();
  }

  function bindLauncher() {
    var launcher = getLauncher();

    if (!launcher || launcher.dataset.blyChatBound === 'true') {
      return;
    }

    launcher.dataset.blyChatBound = 'true';
    launcher.hidden = false;
    launcher.addEventListener('click', openKustomer);
  }

  window.blyLoadKustomer = loadKustomer;
  window.blyOpenKustomer = openKustomer;
  document.addEventListener('DOMContentLoaded', bindLauncher);
})();
